import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Home } from "lucide-react";
import "../../../assets/css/seller/sellerTopbar/SellerTopBar.css";

const SellerTopBar = ({ title, breadcrumbs = [] }) => {
  return (
    <div className="seller-topbar">
      <div className="topbar-content">
        <div>
          <h2 className="page-title" style={{ color: "#000000" }}>
            {title}
          </h2>

          <Breadcrumb className="seller-breadcrumb">
            {/* Home icon only — no text, avoids duplicating the page label */}
            <Breadcrumb.Item href="/seller-dashboard">
              <Home size={14} className="me-1" />
            </Breadcrumb.Item>

            {breadcrumbs.map((item, index) => (
              <Breadcrumb.Item
                key={index}
                href={item.href}
                active={index === breadcrumbs.length - 1}
              >
                {item.label}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        </div>
      </div>
    </div>
  );
};

export default SellerTopBar;